/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivLeadPopulatedViewModelGen,
  MrfiktivLeadResponseControllerGetParamsGen,
  MrfiktivLeadResponseControllerRespondParamsGen,
  MrfiktivLeadResponseDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class LeadResponse<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags lead-response
   * @name LeadResponseControllerGet
   * @summary (SCT) Get a lead
   * @request GET:/partner/{partnerId}/lead-response/{leadId}
   * @secure
   * @response `200` `MrfiktivLeadPopulatedViewModelGen` The found record
   * @response `400` `void` Bad Request.
   * @response `403` `void` Forbidden.
   * @response `404` `void` Lead not found.
   */
  leadResponseControllerGet = (
    { partnerId, leadId, ...query }: MrfiktivLeadResponseControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivLeadPopulatedViewModelGen, void>({
      path: `/partner/${partnerId}/lead-response/${leadId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags lead-response
   * @name LeadResponseControllerRespond
   * @summary (sct) Accepts lead
   * @request PATCH:/partner/{partnerId}/lead-response/{leadId}
   * @secure
   * @response `201` `MrfiktivLeadPopulatedViewModelGen` The updated lead
   */
  leadResponseControllerRespond = (
    { partnerId, leadId, ...query }: MrfiktivLeadResponseControllerRespondParamsGen,
    data: MrfiktivLeadResponseDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivLeadPopulatedViewModelGen, any>({
      path: `/partner/${partnerId}/lead-response/${leadId}`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
